//川源机械定制界面路由
export default [
  //介质列表(cyjx)
  {
    path: "/:lang/Corp/CYJX/EBook/ApplicationJieZhiMain",
    name: "CYJXApplicationJieZhiMain",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebookByCYJX",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () =>
      import("/@/views/Corp/CYJX/EBook/ApplicationJieZhiMain.vue"),
  },
];
